import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackBlockClick, trackBlockShow } from './tracking';
import { PromoOffersList } from '../../components/PromoOffersList';
import { listingUrlSelector } from '../../selectors/promoOffersSelection';
import {
  selectPromoOffers,
  promoOffersIdsSelector,
  selectPromoOffer,
} from '../../selectors/promoOffersSelection/promoOffersSelector';
import { IApplicationState } from '../../types/redux';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';
import { PromoModal } from '../PromoOfferCardContainer/PromoModal';

export const PromoOffersSelection = () => {
  const url = useSelector(listingUrlSelector);
  const offers = useSelector(selectPromoOffers);
  const offersIds = useSelector(promoOffersIdsSelector);

  const [promoModalOpened, setPromoModalOpened] = React.useState(false);
  const [cardId, setCardId] = React.useState(0);

  const promoOffer = useSelector((state: IApplicationState) => selectPromoOffer(state, cardId));

  const onListShow = React.useCallback(() => {
    trackBlockShow(offers);
  }, [offers]);

  const onListingClick = React.useCallback(() => {
    trackBlockClick({ offersIds, clickType: 'to_listing' });
  }, [offersIds]);

  const onListingModalClick = React.useCallback(() => {
    trackBlockClick({ offersIds, clickType: 'to_listing_modal' });
  }, [offersIds]);

  const onPromoModalClose = React.useCallback(() => {
    setPromoModalOpened(false);
  }, []);

  const onPromoLabelClick = React.useCallback((cardId: number) => {
    setCardId(cardId);
    setPromoModalOpened(true);
  }, []);

  if (!url || !offers.length) {
    return null;
  }

  return (
    <>
      <PromoOffersList
        title="Могут подойти"
        subtitle="Выгодные предложения по вашим поискам"
        offers={offers}
        url={url}
        onListShow={onListShow}
        onListingClick={onListingClick}
        onListingModalClick={onListingModalClick}
        onPromoLabelClick={onPromoLabelClick}
      />
      <PromoOfferCardContext.Provider value={promoOffer}>
        {promoModalOpened && <PromoModal onPromoModalClose={onPromoModalClose} />}
      </PromoOfferCardContext.Provider>
    </>
  );
};
